import { formatDate, formatTime12Hr } from "./format";

const FOOTER = "_DOTIZO ADVERTISING.LLC - Order & Schedule Portal_";

const DAY_LABELS = { today: "TODAY", tomorrow: "TOMORROW", in_2_days: "IN 2 DAYS" };

/* Job deadlines read "JOB DEADLINE: JO-2026-001 - Customer" in alerts and WhatsApp messages. */
export const alertTitle = (item) =>
  item.source === "job" ? `JOB DEADLINE: ${item.job_no} - ${item.customer_name}` : item.title;

/* The line shown in the calendar's "Date Reminders & Alerts" box. */
export const alertMessage = (item) => {
  const time = formatTime12Hr(item.time) || "All day";
  if (item.source === "job") {
    const prefix = item.alert === "today" ? "URGENT DEADLINE TODAY" : "UPCOMING DEADLINE TOMORROW";
    return `${prefix} (${time}): ${item.job_no} - ${item.customer_name}`;
  }
  return `${DAY_LABELS[item.alert] || "UPCOMING"} (${time}): ${item.title}`;
};

export const reminderText = ({ title, date, time, location, description }) => {
  let text = "🚨 *DOTIZO SCHEDULE REMINDER* 🚨\n\n";
  if (title) text += `📌 *Title:* ${title}\n`;
  if (date) text += `📅 *Date:* ${formatDate(date)}\n`;
  if (time) text += `⏰ *Time:* ${formatTime12Hr(time)}\n`;
  if (location) text += `📍 *Location:* ${location}\n`;
  if (description) text += `📝 *Details:* ${description}\n`;
  return `${text}\n${FOOTER}`;
};

export const digestText = (alerts) => {
  let text = "🚨 *DOTIZO DAILY REMINDERS DIGEST* 🚨\n\n";
  alerts.forEach((item, index) => {
    const time = formatTime12Hr(item.time) || "All day";
    text += `${index + 1}. *[${DAY_LABELS[item.alert] || "UPCOMING"} - ${time}]* ${alertTitle(item)}\n`;
  });
  return `${text}\n${FOOTER}`;
};

/* wa.me-style share link; with a phone number the chat opens straight to that contact. */
export const whatsAppUrl = (text, phone = "") => {
  const digits = String(phone || "").replace(/\D/g, "");
  const phoneParam = digits ? `phone=${digits}&` : "";
  return `https://api.whatsapp.com/send?${phoneParam}text=${encodeURIComponent(text)}`;
};

export const openWhatsApp = (text, phone) => {
  window.open(whatsAppUrl(text, phone), "_blank", "noopener");
};
